import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { ConnectedDotsIcon } from '../../Icons/ConnectedDotsIcon'
import { TransitionButton } from '../../Buttons/TransitionButton'
import { OfferDeclinedComponentProps } from './types'

export const ApplicationOfferDeclined: React.FC<
  OfferDeclinedComponentProps
> = ({ handleDone }) => {
  return (
    <Stack spacing={3} sx={{ maxWidth: 400 }}>
      <Typography variant="h5" component="div" align="center" gutterBottom>
        Offer declined
      </Typography>

      <div style={{ textAlign: 'center' }}>
        <ConnectedDotsIcon sx={{ height: '1em', width: '2em' }} />
      </div>

      <Typography variant="body1" component="div" align="center" gutterBottom>
        Thank you for considering us for your credit needs. We are sad to see
        you go. If you change your mind, please come back and apply again.
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center'
        }}
      >
        <TransitionButton
          text="Done"
          onClick={handleDone}
          style={{ width: '8rem' }}
        />
      </Box>
    </Stack>
  )
}
